export default function SectionCard({ icon, iconBg, title, subtitle, children }) {
  return (
    <div className="w-full bg-scabWhite rounded-[16px] p-4 mb-4 shadow-sm">
      {(title || icon) && (
        <div className="flex items-start mb-4">
          {icon ? (
            <div
              className={`w-[40px] h-[40px] rounded-full flex items-center justify-center ml-3 shrink-0 ${iconBg}`}
            >
              {icon}
            </div>
          ) : null}
          <div className="flex-1">
            {title ? (
              <div className="font-IRANSansBold text-large text-scabBlack">
                {title}
              </div>
            ) : null}
            {subtitle ? (
              <div className="text-small text-scabBtnGray mt-1 leading-6">
                {subtitle}
              </div>
            ) : null}
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
